import {useMemo} from 'react';

import {useStatsigGateAutomationHubFrontend} from '../../../util/rampFeatureFlags/rampFeatureFlags';
import {useAutomationsOrgScope} from './useAutomationsOrgScope';

export function useIsAutomationHubEnabled(): {
  isAutomationHubEnabled: boolean;
  isAutomationHubLoading: boolean;
} {
  const {orgName, isPersonalAccountOnSaaS} = useAutomationsOrgScope();
  const {enabled, loading} = useStatsigGateAutomationHubFrontend(orgName);

  return useMemo(
    () => ({
      isAutomationHubEnabled: !isPersonalAccountOnSaaS && enabled,
      isAutomationHubLoading: !isPersonalAccountOnSaaS && loading,
    }),
    [enabled, loading, isPersonalAccountOnSaaS]
  );
}
